import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFilterList = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgFilterList" data-sentry-source-file="filter-list.tsx">
    <path fill="#263E6A" d="M10 18h4v-2h-4zM3 6v2h18V6zm3 7h12v-2H6z" data-sentry-element="path" data-sentry-source-file="filter-list.tsx" />
  </svg>;
export default SvgFilterList;